module.exports = __webpack_public_path__ + "fontawesome-webfont.fee66e712a8a08eef580.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font-awesome-4.7.0/fonts/fontawesome-webfont.woff?v=4.7.0
// module id = 890
// module chunks = 3